import { t } from '@web-solutions/module-localization';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import styles from '../../styles/style.module.scss';
import people from '../../../personal-plan-metabolism/styles/people.png';

export const JoinedPeopleComponent = () => {
  return (
    <div className={styles.people}>
      <Text size='m' regular style={{ color: '#3F3F3F' }}>
        <span>1,211 </span>
        {t('onboarding.personalPlanMetabolism.tryFoodzee.people')}
      </Text>
      <img src={people} className={styles.peopleImage} alt='people' />
    </div>
  );
};
